import { Component, OnInit, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { GenericMetricFormatterPipe } from 'src/app/reusables/pipes/generic-metric-formatter.pipe';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { GamesService } from 'src/app/gamification/command-center/services/games.service';
import { AgGridHelperService } from 'src/app/reusables/services/ag-grid-helper.service';
import { GridOptions, GridReadyEvent, GridSizeChangedEvent, ICellRendererParams } from 'ag-grid-community';
import { MilestoneBadgesRendererComponent } from '../../renderers/milestone-badges-renderer/milestone-badges-renderer.component';
import { MilestoneResultsRendererComponent } from '../../renderers/milestone-results-renderer/milestone-results-renderer.component';
import { AgGridAngular } from 'ag-grid-angular';

@Component({
  selector: 'cv-reward-estimator-table',
  templateUrl: './reward-estimator-table.component.html',
  styleUrls: ['./reward-estimator-table.component.scss']
})
export class RewardEstimatorTableComponent implements OnInit, OnChanges {
  @Input() participants: any;
  @ViewChild('rewardEstimatorTableGrid') agGrid: AgGridAngular;
  @Input() isRaffle: boolean = false;

  gs: any = null;
  gameSelected = null;
  gamesf = null;
  grid: GridOptions;
  selectedGame = null;
  localizationMessages = new Map();

  constructor(
    private gamesService: GamesService,
    private cvLocalizationService: CVLocalizationService,
    private metricFormatPipe: GenericMetricFormatterPipe,
    private agGridHelperService: AgGridHelperService,
  ) {
    this.gs = this.gamesService.data;
    this.selectedGame = [this.gs.modified.item];
  }

  ngOnInit(): void {
    this.cvLocalizationService.GetSection("Games_History").then((result) => {
      this.localizationMessages = result;
      this.setupGrid();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.participants != undefined && changes.participants.currentValue != null) {
      if (this.grid) this.agGrid?.api?.showLoadingOverlay();
      if (this.grid && this.agGrid.api && this.participants.length > 0) {
        const newParticipants = changes.participants.currentValue;
        this.agGrid.api.setGridOption('rowData', newParticipants);

        this.agGrid.api.autoSizeAllColumns();
        this.agGrid.api.sizeColumnsToFit();

        this.agGrid.api.refreshHeader();

        if (newParticipants.length === 0) {
          this.agGrid.api.showNoRowsOverlay();
        } else {
          this.agGrid.api.hideOverlay();
        }
      }
    } else {
      if (this.grid && this.grid.api) {
        //To clear the table
        this.agGrid?.api?.setGridOption('rowData', null);
        //this.agGrid?.api?.setRowData(null);
      }
    }
  }

  setupGrid(): void {
    //Create grid options
    this.grid = {
      components: {
        MilestoneBadgesRendererComponent,
        MilestoneResultsRendererComponent,
        customLoadingOverlay: this.agGridHelperService.loadingOverlay,
      },
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
        width: 200
      },
      groupDisplayType: 'custom',
      groupHideOpenParents: true,
      enableRangeSelection: true,
      animateRows: true,
      groupIncludeFooter: true,
      suppressAggFuncInHeader: true,
      columnDefs: this.getColDefs(),
      rowData: null,
      loadingOverlayComponent: 'customLoadingOverlay',
      noRowsOverlayComponent: 'customLoadingOverlay',
      getLocaleText: this.agGridHelperService.getLocaleText,
      onGridReady(params: GridReadyEvent) {
        if (this.participants && this.participants.length > 0) {
          
          params.api.setGridOption('rowData', this.participants);

          params.api.autoSizeAllColumns();

          if (this.participants.length > 0) {
            params.api.hideOverlay();
            params?.api?.sizeColumnsToFit();
          } else {
            params.api.showNoRowsOverlay();
          }
        }
      },
      onGridSizeChanged: (e: GridSizeChangedEvent) => {
        e.api.sizeColumnsToFit();
      }
    }
  }

  getColDefs(): any {
    let resultsArray = [];
    let interval = {
      headerName: this.getLocalizedMessage('Interval', 'Interval'),
      children: [{
        headerName: '',
        showRowGroup: 'Interval.DisplayStringDate',
        cellRenderer: 'agGroupCellRenderer',
        minWidth: 190,
        suppressColumnsToolPanel: true,
        cellRendererParams: {
          suppressColumnsToolPanel: true,
          footerValueGetter: params => '',
        }
      }]
    }

    resultsArray.push(interval);
    const nameWidth = this.isRaffle ? { minWidth: 180 } : {};
    const metricWidth = this.isRaffle ? { minWidth: 125 } : {};
    let participant = {
      headerName: this.getLocalizedMessage('Player', 'Player'),
      children: [{
        field: 'Participant.participant.LoginName',
        headerName: this.getLocalizedMessage('Name', 'Name'),
        filter: 'agTextColumnFilter',
        ...nameWidth,
        cellRenderer: (params) => {
          if (params.node.aggData) {
            return this.getLocalizedMessage('Total_Players', 'Total Players') + ': ' + params.node.allLeafChildren.length;
          }

          if (!params.value) {
            return '';
          }

          if (!params.data.hasOwnProperty('participantst')) {
            let $productContainer = $('<div>').addClass('d-flex');
            // Product image
            let imageId = params.data && params.data.Participant && params.data.Participant.ImageID > 0 ? params.data.Participant.ImageID : "";
            let $img = $('<img>').addClass('mr-3').css({ 'height': 25, 'border-radius': '50%' }).appendTo($productContainer);
            $img.attr('src', `${_BaseURI}/Admin/ImageResizer.aspx?imgid=${imageId}&w=auto&h=25`);
            $img.on('error', () => $img.attr('src', `${_BaseURI}/Admin/ImageResizer.aspx?imgid=&w=auto&h=26`));
  
            // Product name
            $('<span>').text(params.value).appendTo($productContainer)
            return $productContainer[0];
          } else {
            return params.data.participantst;
          }
        }
      }]
    }

    let groupParticipant = {
      headerName: this.getLocalizedMessage('Player', 'Player'),
      children: [{
        field: 'GroupParticipant.participant.GroupName',
        headerName: this.getLocalizedMessage('Name', 'Name'),
        filter: 'agTextColumnFilter',
        ...nameWidth,
        cellRenderer: (params) => {
          if (params.node.aggData) {
            return this.getLocalizedMessage('Total_Players', 'Total Players') + ': ' + params.node.allLeafChildren.length;
          }

          if (!params.value) {
            return '';
          }

          if (!params.data.hasOwnProperty('participantst')) {
            let $productContainer = $('<div>').addClass('d-flex');
            // Product image
            let imageId = params.data && params.data.Participant && params.data.Participant.ImageID > 0 ? params.data.Participant.ImageID : "";
            let $img = $('<img>').addClass('mr-3').css({ 'height': 25, 'border-radius': '50%' }).appendTo($productContainer);
            $img.attr('src', `${_BaseURI}/Admin/ImageResizer.aspx?imgid=${imageId}&w=auto&h=25`);
            $img.on('error', () => $img.attr('src', `${_BaseURI}/Admin/ImageResizer.aspx?imgid=&w=auto&h=26`));
            
            // Product name
            $('<span>').text(params.value).appendTo($productContainer)
            return $productContainer[0];
          } else {
            return params.data.participantst;
          }
        }
      }]
    }

    if (this.gs.selectedGame && this.gs.selectedGame[0] && this.gs.selectedGame[0].underlyingRule.GameType == 8) {
      resultsArray.push(groupParticipant);
    } else {
      resultsArray.push(participant);
    }

    let metric = null;
    //Configure metric column for Connect 3 or Connect All Games
    if (this.gs.selectedGame && this.gs.selectedGame[0] && (this.gs.selectedGame[0].underlyingRule.GameType == 6 || this.gs.selectedGame[0].underlyingRule.GameType == 7)) {
      let connect3Metrics = [];
      for (let i = 0; i < 9; i++) {
        let metricTemp = {
          headerValueGetter: params => {
            if (this.gs.selectedGame.length > 0 && this.gs.selectedGame[0].Connect3Positions[i].metric.metricID != -1) {
              let metricString = this.gs.selectedGame[0].Connect3Positions[i].metric.abbrev;
                metricString += this.gs.selectedGame[0].Connect3Positions[i].metric.direction === "0" || this.gs.selectedGame[0].Connect3Positions[i].metric.direction === 0 ? "≤" : "≥";
              metricString += this.getFormattedMetric(this.gs.selectedGame[0].Connect3Positions[i].targetObj.Target, this.gs.selectedGame[0].Connect3Positions[i].metric.conversionType);
              return metricString;
            } else {
              return this.gs.selectedGame[0].Connect3Positions[i].metric.abbrev;
            }
          },
          cellRenderer: (params) => {
            if (!(params.data && params.data.connect3Metrics && params.data.connect3Metrics[i])) {
              return '';
            }

            if (this.gs.selectedGame.length > 0 && this.gs.selectedGame[0].Connect3Positions[i].metric.metricID != -1) {
                let condition = this.gs.selectedGame[0].Connect3Positions[i].metric.direction === "0" || this.gs.selectedGame[0].Connect3Positions[i].metric.direction === 0 ? params.data.connect3Metrics[i].MyMetricValue < this.gs.selectedGame[0].Connect3Positions[i].targetObj.Target : params.data.connect3Metrics[i].MyMetricValue > this.gs.selectedGame[0].Connect3Positions[i].targetObj.Target;
              let mark = condition ? '<svg class="icon-16 fill-emeraldCity ml-3"><use href="../App_Themes/clearview-default/icons/utility/checkmark.svg#checkmark"></use></svg>' : '<svg class="icon-16 fill-redRyder ml-3"><use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use></svg>';
              return params.data.connect3Metrics && params.data.connect3Metrics[i] ? this.getFormattedMetric(params.data.connect3Metrics[i].MyMetricValue, this.gs.selectedGame[0].Connect3Positions[i].metric.conversionType) + mark : '';
            } else if (this.gs.selectedGame[0].Connect3Positions[i].metric.metricID == -1) {
              return '<svg class="icon-16 fill-emeraldCity ml-3"><use href="../App_Themes/clearview-default/icons/utility/checkmark.svg#checkmark"></use></svg>';
            } else {
              return '';
            }
          },
          columnGroupShow: i != 0 ? 'open' : false
        }
        connect3Metrics.push(metricTemp);
      }

      metric = {
        headerName: this.getLocalizedMessage('Metric_Total', 'Metric Total'),
        children: connect3Metrics,
      };
    } else {
      metric = {
        headerName: this.getLocalizedMessage('Metric_Total', 'Metric Total'),
        children: [{
          field: 'metric',
          ...metricWidth,
          headerValueGetter: params => {
            if (this.gs.selectedGame.length > 0) {
              return this.gs.selectedGame[0].SelectedMetrics[0].name;
            }
            return '--';
          },
        }]
      };
    }
    resultsArray.push(metric);

    //Define and insert qualifier column if the game have one
    if (this.gs.selectedGame.length > 0 && this.gs.selectedGame[0].Qualifier) {
      let qualifier = {
        headerName: this.getLocalizedMessage('Qualifier_Metric', 'Qualifier Metric'),
        children: [{
          field: 'qualifier',
          ...metricWidth,
          headerValueGetter: params => {
            if (this.gs.selectedGame.length > 0) {
              return this.gs.selectedGame[0].Qualifier ? this.gs.selectedGame[0].Qualifier.name : this.getLocalizedMessage('None', 'None');
            }
            return '--';
          },
        },
        {
          field: 'passed',
          headerName: this.getLocalizedMessage('Player_Passed', 'Passed?'),
          minWidth: 60,
          cellRenderer: (params) => {
            if (params.value === undefined)
              return '';
            let approve = ' ';
            if (this.gs.selectedGame.length > 0 && this.gs.selectedGame[0].Qualifier) {
              approve = params.value ? '<svg class="icon-16 fill-emeraldCity"><use href="../App_Themes/clearview-default/icons/utility/checkmark.svg#checkmark"></use></svg>' : '<svg class="icon-16 fill-redRyder"><use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use></svg>';
            } else {
              approve = '--';
            }
            return approve;
          },
          filterParams: {
            cellRenderer: (params) => {
              if (params.value === undefined)
                return '';

              let approve = ' ';
              if (this.gs.selectedGame.length > 0 && this.gs.selectedGame[0].Qualifier) {
                approve = JSON.parse(params.value.toLowerCase()) ? '<svg class="icon-16 fill-emeraldCity"><use href="../App_Themes/clearview-default/icons/utility/checkmark.svg#checkmark"></use></svg>' : '<svg class="icon-16 fill-redRyder"><use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use></svg>';
              } else {
                approve = '--';
              }
              return approve;
            }
          }
        }]
      };
      resultsArray.push(qualifier);
    }

    //Include results column if the game is not Multiplier Madness
    if (this.gs.selectedGame.length > 0 && this.gs.selectedGame[0].underlyingRule.GameType != 1) {
      let results = {
        headerName: " ",
        children: [{
          field: 'results',
          ...metricWidth,
          headerName: this.getLocalizedMessage('Results', 'Results'),
          cellRenderer: 'MilestoneResultsRenderer',
          cellRendererParams: { participant: this.participants[0] },
        }]
      };
      resultsArray.push(results);
    }

    const raffleColumn= this.isRaffle ? [{
      field: 'calculatedCustom',
      headerName: this.getLocalizedMessage('Custom_Rewards', 'Custom Rewards'),
      sortable: false,
      cellRenderer: (params) => {
        if (!params.value)
          return '---';
        return params.value;
      },
      minWidth: 150,
    }] : [];

    const minWidthValues = this.isRaffle ? {
      minWidth: 60,
    } : {};

    let rewards = {
      headerName: this.getLocalizedMessage('Reward', 'Reward'),
      children: [{
        field: 'calculatedCoins',
        headerName: this.getLocalizedMessage('Coins', 'Coins'),
        filter: 'agNumberColumnFilter',
        aggFunc: 'sum',
        cellRenderer: (params) => {
          if (!params.value)
            return '---';
          return params.value;
        },
        ...minWidthValues,
      },
      {
        field: 'calculatedXP',
        headerName: this.getLocalizedMessage('XP', 'XP'),
        filter: 'agNumberColumnFilter',
        aggFunc: 'sum',
        cellRenderer: (params) => {
          if (!params.value)
            return '---';
          return params.value;
        },
        ...minWidthValues,
      },
      {
        field: 'badges',
        headerName: this.getLocalizedMessage('Badges', 'Badges'),
        cellRenderer: (params) => {
          if (!params.value)
            return '---';
          if (params.value.length > 0) {
            let badge = `<img src="../Admin/ImageResizer.aspx?imgid=${params.value[0]}&w=26&h=26" class="img-fluid" />`;

            if (this.gs.selectedGame && this.gs.selectedGame[0] && this.gs.selectedGame[0].underlyingRule.GameType == 5 && params.value.length > 1) {
              badge += `<milestone-badges-popover badges='data.badges' \><span class='color-whaleTail lato-regular font-size-14'>+${params.value.length - 1}</span><milestone-badges-popover/>`;
            }

            return badge;
          } else if (typeof params.value === 'number') {
            return params.value;
          } else {
            return '---'
          }
        },
        filterParams: {
          cellRenderer: (params) => {
            return params.value;
          }
        },
        sortable: false,
        ...minWidthValues,
      },
      ...raffleColumn,
    ],
    };
    resultsArray.push(rewards);

    resultsArray.push({ field: 'Interval.DisplayStringDate', rowGroup: true, hide: true });
    return resultsArray;
  }

  getLocalizedMessage(key: string, fallback: string): string {
    if (this.localizationMessages && this.localizationMessages.has(key)) {
      return this.localizationMessages.get(key);
    }
    else { return fallback; }
  }

  getFormattedMetric(value: number, format: string): string {
    return this.metricFormatPipe.transform(value, format);
  }
}
